import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { MyWaitroseCard } from '@johnlewispartnership/wtr-style-dictionary/icons/react/Cards';
import styles from './MyWaitrose.scss';

const MyWaitrose = ({ isSubPod = false, promotion, noMargins = false }) => {
  if (!promotion?.myWaitrosePromotion) return null;

  return (
    <div
      className={classNames(styles.myWaitrose, {
        [styles.noMargins]: noMargins,
        [styles.subPod]: isSubPod,
      })}
      data-testid="my-waitrose-icon"
    >
      <MyWaitroseCard className={styles.myWpopOverBtn} size="small" />
    </div>
  );
};

MyWaitrose.displayName = 'MyWaitrose';

MyWaitrose.propTypes = {
  promotion: PropTypes.shape({
    myWaitrosePromotion: PropTypes.bool,
  }),
};

export default MyWaitrose;
